import { render } from 'preact';

import '@shared/styles/index.scss';

import { AppInit } from './AppInit';
import App from './App';

import './index.css';

const root = document.getElementById('root');
render(
	<AppInit>
		<App />
	</AppInit>,
	root!,
);
